import { Component, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PaymentService } from 'src/app/assabil-sales/services/payment-service';
import { Payment } from 'src/app/assabil-sales/models/entities/payment';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/assabil-kernel/services/user-service';


@Component({
    selector: 'payment-widget',
    templateUrl: './payment-widget.component.html',
    styleUrls: ['./payment-widget.component.scss']
})

export class PaymentWidgetModal extends BaseWidget {
  
  payment   : Payment = new Payment();

 //---------------------------------------------------------------------------------------
 constructor(
  public dialogRef: MatDialogRef<PaymentWidgetModal>,
      @Inject(MAT_DIALOG_DATA) public params: any,
      protected toastr                : ToastrService,
      protected leanUtilsService      : LeanUtilsService,
      protected controlTablesService  : ControlTablesService,
      protected userService           : UserService,
      protected paymentService        : PaymentService) {
      super(toastr, leanUtilsService);

      this.entityName = "payment";

      if (params) {
        this.setBaseEntity(params.payment);
        this.columns = params.columns;
      }
  }
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
setEntity(payment: Payment) {
      this.payment  = { ...payment };
}
//---------------------------------------------------------------------------------------

  
//---------------------------------------------------------------------------------------
  getEntity(){
    return this.payment;
  }
//---------------------------------------------------------------------------------------


//----------------------------------------------------------------------
saveRow(): Promise<Payment> {
  this.modificationsDone = true;
  return this.paymentService.paymentSave(this.payment);
}
//----------------------------------------------------------------------

//---------------------------------------------------------------------------------------------------------
new() {
  let payment          = new Payment();
  payment.person       = this.userService.userInfo.person
  payment.role         = this.userService.userInfo.person.role;
  payment.paymentTerm  = this.payment.paymentTerm;
  payment.service      = this.payment.service;
  payment.theDate      = new Date();
  payment.edit         = true; 
  payment.inserted     = true; 
  this.setBaseEntity(payment);
}
//---------------------------------------------------------------------------------------------------------
  

//----------------------------------------------------------------------
modificationsDone : boolean = false;
close(){
  this.dialogRef.close(this.modificationsDone);
}
//----------------------------------------------------------------------

}
